// extracted by mini-css-extract-plugin
export default {"mainContainer":"Benchmark__mainContainer___etsdZ","subjectBenchmarkContainer":"Benchmark__subjectBenchmarkContainer___fYVkG"};